import type { ComponentType, ReactNode } from 'react';
import { Form as FormikForm } from 'formik';
import { FormikInput } from 'Components/frameworks/formik/FormikInput';
import type { ExtendedFormikInputProps } from 'Src/types/payment';

export const PaymentFormikInput = FormikInput as unknown as ComponentType<ExtendedFormikInputProps>;

export const PaymentFormikForm = FormikForm as unknown as ComponentType<{
  className?: string;
  children?: ReactNode;
}>;
